import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../utils/constants';
import { getAuthToken } from '../../utils/authToken';

const contactsTimestamp = (data) => {
  if (!data?.updatedAt) return 0;
  const value = Date.parse(data.updatedAt);
  return Number.isNaN(value) ? 0 : value;
};

export const getContacts = createAsyncThunk(
  'contacts/getContacts',
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BASE_URL}/contacts`);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const updateContacts = createAsyncThunk(
  'contacts/updateContacts',
  async (payload, thunkAPI) => {
    try {
      const token = getAuthToken(thunkAPI.getState);
      if (!token) {
        throw new Error('Токен не знайдено');
      }
      const res = await axios.post(`${BASE_URL}/contacts`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const contactsSlice = createSlice({
  name: 'contacts',
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContacts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getContacts.fulfilled, (state, action) => {
        state.isLoading = false;
        const incomingTs = contactsTimestamp(action.payload);
        const currentTs = contactsTimestamp(state.data);
        if (currentTs > incomingTs) {
          return;
        }
        state.data = action.payload;
      })
      .addCase(getContacts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateContacts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateContacts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(updateContacts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default contactsSlice.reducer;
